
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

/** support components */
const DIRECTIVES = [

];


const MODULES = [
  CommonModule, FormsModule, HttpClientModule, ReactiveFormsModule,
];


@NgModule({
  declarations: [...DIRECTIVES],
  imports: [
    ...MODULES
  ],
})
export class ShareModule { }
